import { render } from "./Ordination.vue?vue&type=template&id=26e97f03&scoped=true"
import script from "./Ordination.vue?vue&type=script&lang=js"
export * from "./Ordination.vue?vue&type=script&lang=js"

import "./Ordination.vue?vue&type=style&index=0&id=26e97f03&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e97f03"]])

export default __exports__